export default __webpack_public_path__ + "static/media/visa.71c0d5e9.png";